import styled, { css } from 'styled-components';
export const receiptModalStyles = ({ theme, $isOpen }) => css `
	${$isOpen &&
    css `
		z-index: ${theme.zIndex.popUp};
		position: fixed;
		inset: 0;
		display: flex;
		flex-direction: column;
		overflow-y: auto;
		background-color: ${theme.colors.blanc.bgReceipt};
	`};
`;
export const StyledReceiptModal = styled.div `
	${receiptModalStyles}
`;
export const receiptModalContentStyles = ({ $isOpen }) => css `
	flex: 1;

	${!$isOpen &&
    css `
		display: none;
	`}
`;
export const StyledReceiptModalContent = styled.div `
	${receiptModalContentStyles}
`;
